import { parseURL, withQuery } from 'ufo';

export function mergeDefaultParams(
  url: string,
  defaultParams: Record<string, string | number>,
) {
  const { pathname, search } = parseURL(url);
  const currentParams = Object.fromEntries(new URLSearchParams(search));
  const mergedParams = { ...defaultParams, ...currentParams };
  return withQuery(pathname, mergedParams);
}
